import script from "./ADialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./ADialog.vue?vue&type=script&lang=ts&setup=true"

import "./ADialog.vue?vue&type=style&index=0&id=b7f8da88&lang=scss&scoped=true"
import "./ADialog.vue?vue&type=style&index=1&id=b7f8da88&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7f8da88"]])

export default __exports__